import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTugt = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_384",
	"data-name": "Group 384",
	xmlns: "http://www.w3.org/2000/svg",
	width: 13.799,
	height: 14.16,
	viewBox: "0 0 13.799 14.16",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			id: "Path_462",
			"data-name": "Path 462",
			d: "M170.467,754.166v-1.185a1.5,1.5,0,0,0-1.5-1.5h-1.944a1.5,1.5,0,0,0-1.5,1.5v1.181a5.994,5.994,0,0,0-.919.514.712.712,0,0,0,.805,1.174,4.585,4.585,0,1,1-1.933,4.506l.728.728a.712.712,0,0,0,1.007-1.007l-1.9-1.9a.711.711,0,0,0-1.007,0l-1.9,1.9a.712.712,0,1,0,1.007,1.007l.633-.633a6,6,0,1,0,8.417-6.286Zm-3.522-.443v-.741a.077.077,0,0,1,.077-.077h1.944a.077.077,0,0,1,.077.077v.744a5.762,5.762,0,0,0-2.1,0Z",
			transform: "translate(-160.202 -751.48)",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_463",
			"data-name": "Path 463",
			d: "M180.8,763.463a.712.712,0,0,0-.712.712v3.175a.712.712,0,0,0,.209.5l1.709,1.71a.712.712,0,0,0,1.007-1.007l-1.5-1.5v-2.881A.712.712,0,0,0,180.8,763.463Z",
			transform: "translate(-173.011 -759.197)",
			fill: "current"
		})
	]
});
const ForwardRef = forwardRef(SvgTugt);
export { ForwardRef as ReactComponent };
